"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PageHeader = require("./PageHeader");
Object.keys(_PageHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PageHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PageHeader[key];
    }
  });
});